/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material

// styles
import injectSheet from 'react-jss';
import styles from 'material/expandablesection/sectiongroupdescription/sectiongroupdescription_styles';


const SectionGroupDescription = (props) => {
  const {
    title,
    description,
    helpLink
  } = props
  return <div className={`sectiongroupdescription ${props.classes.sectiongroupdescription}`}>
    <h2>
      {title}
      {helpLink && <Link
        icon='question-circle'
        action={helpLink}
        operation='link'
        type='external'
      />
      }
    </h2>
    {description && <h4>{description}</h4>}
  </div>
}

export default injectSheet(styles)(SectionGroupDescription)